import React, { forwardRef } from 'react';
import MuiButton from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import styles, { NEW_DESIGN_OVERRIDES } from './styles';
export var Button = /*#__PURE__*/forwardRef(function Button(props, ref) {
  return /*#__PURE__*/React.createElement(MuiButton, Object.assign({
    ref: ref
  }, props));
});
export default withStyles(styles(), {
  name: 'MuiButton'
})(Button);

var _ButtonNew = /*#__PURE__*/forwardRef(function _ButtonNew(props, ref) {
  var design = props.design;
  var overrideProps = {};

  switch (design) {
    case 'primary':
      overrideProps.variant = 'contained';
      overrideProps.color = 'primary';
      break;

    case 'secondary':
      overrideProps.variant = 'outlined';
      break;

    case 'text':
    default:
      overrideProps.color = 'primary';
      break;
  }

  return /*#__PURE__*/React.createElement(MuiButton, Object.assign({
    ref: ref
  }, props, overrideProps));
});

export var ButtonNew = withStyles(styles(function () {
  return NEW_DESIGN_OVERRIDES;
}), {
  name: 'MuiButtonNew'
})(_ButtonNew);